// extracted by mini-css-extract-plugin
export var chevron = "_dn-4";
export var chevronExpanded = "_dn-5";
export var row = "_dn-0";
export var rowBody = "_dn-6";
export var rowDescription = "_dn-7";
export var rowHeader = "_dn-1";
export var rowTitle = "_dn-2";
export var rowTitleComplete = "_dn-3";